import type { FC } from 'react';
import { Helmet } from 'react-helmet-async';

import { CoverImages } from './use-cover-media';

type PreloadCoverProps = {
  covers: NonNullable<CoverImages>;
};
export const PreloadCover: FC<PreloadCoverProps> = ({ covers }) => {
  return (
    <Helmet>
      {covers[0]?.url ? (
        <link
          rel="preload"
          href={covers[0].url}
          as="image"
          media="(max-width: 600px)"
        />
      ) : null}
      {covers[1]?.url ? (
        <link
          rel="preload"
          href={covers[1].url}
          as="image"
          media="(min-width: 601px)"
        />
      ) : null}
    </Helmet>
  );
};
